import React, { useMemo } from 'react';

/**
 * Unsent room-chat text lives above the right-panel switch and the
 * phone sheet. The key is the book and the room, so Outline and Write
 * keep separate lines, and a second book does not see the first.
 */
export const RoomChatDraftContext = React.createContext(null);

export function roomChatDraftKey(storyId, roomKey) {
  if (!storyId || !roomKey) return '';
  return `${storyId}:${roomKey}`;
}

export function useRoomChatDraft() {
  return React.useContext(RoomChatDraftContext);
}

export function RoomChatDraftProvider({
  storyId,
  roomKey,
  drafts,
  onChange,
  children,
}) {
  const key = roomChatDraftKey(storyId, roomKey);
  const text = key ? (drafts?.[key] || '') : '';
  const value = useMemo(() => {
    if (!key) return null;
    return {
      key,
      text,
      setText: (next) => onChange(key, next),
    };
  }, [key, text, onChange]);

  if (!value) return children;
  return (
    <RoomChatDraftContext.Provider value={value}>
      {children}
    </RoomChatDraftContext.Provider>
  );
}
